import { render, staticRenderFns } from "./PathTab.vue?vue&type=template&id=0934e3b9&scoped=true"
import script from "./PathTab.vue?vue&type=script&lang=js"
export * from "./PathTab.vue?vue&type=script&lang=js"
import style0 from "./PathTab.vue?vue&type=style&index=0&id=0934e3b9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0934e3b9",
  null
  
)

export default component.exports